window.SliderMin = null;
window.SliderMax = null;

window.displayVal1 = null;
window.displayVal2 = null;

window.sliderTrack = null;

var sliderMaxValue = 50000000;
var sliderMinValue = 0;
var minGap = 0;

window.ResetAndCallAgainSearch = function()
{
  // Reset Data ---------------------------------------------------------

  window.CurrentPage = 0;
  window.SortedAccommodationData = [];
  window.SearchPaginationData = null;

  let WhereToInstantiate = document.getElementById("SearchResultPanelContainer");
  WhereToInstantiate.innerHTML = "";

  // Set Observer and Load Accommodation ------------------------------------------------

  window.searchobserver.observe(window.ScrollSentinel);
}

window.PrepareSliderValue = function(functionontypechange)
{
  window.SliderMin = document.getElementById("slider-1");
  window.SliderMax = document.getElementById("slider-2");

  // Input Field ---------------------------------

  window.displayVal1 = document.getElementById("InputFieldMin");
  window.displayVal2 = document.getElementById("InputFieldMax");
  window.sliderTrack = document.getElementById("slider-track");

  // Apply Function Slider ------------------------------------------------
  
  window.SliderMin.oninput = function()
  {
    window.OnChangePriceSlider('SliderMax', 'SliderMin', 'displayVal1');
  }
  window.SliderMin.onchange = function()
  {
    // window.ApplyFilter();
    // window.LoadAccommodationBasedOnSort();
    functionontypechange();
  }

  window.SliderMax.oninput = function()
  {
    window.OnChangePriceSlider('SliderMin', 'SliderMax', 'displayVal2');
  }
  window.SliderMax.onchange = function()
  {
    // window.ApplyFilter();
    // window.LoadAccommodationBasedOnSort();
    functionontypechange();
  }

  //-------------------------- INPUT ON CHANGE -----------------------------

  window.displayVal1.onfocus = function()
  {
    window.displayVal1.type = "number";
    window.displayVal1.value = window.displayVal1.getAttribute("current-budget-input");
  }
  window.displayVal1.oninput = function()
  {
   window.displayVal1.value =window.displayVal1.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  }
  window.displayVal1.addEventListener("focusout", (event) =>
  {
    let DataToDisplay;

    if(window.displayVal1.value == "")
    {
      DataToDisplay = parseInt(window.displayVal1.getAttribute("current-budget-input"));
    }
    else if(window.displayVal1.value >= sliderMaxValue)
    {
      DataToDisplay = sliderMaxValue;
    }
    else if(window.displayVal1.value < sliderMinValue)
    {
      DataToDisplay = 0;
    }
    else
    {
      DataToDisplay = window.displayVal1.value;
    }

    if(DataToDisplay > parseInt(window.displayVal2.getAttribute("current-budget-input")))
    {
      window.displayVal2.setAttribute("current-budget-input", DataToDisplay);
      ConvertToIDR(window.displayVal2, DataToDisplay);
      window.SliderMax.value = DataToDisplay;
    }

    window.displayVal1.setAttribute("current-budget-input",window.displayVal1.value);
    ConvertToIDR(window.displayVal1, DataToDisplay);
    
    window.SliderMin.value = DataToDisplay;

    ChangeSwiperColorRange();
    // window.LoadAccommodationBasedOnSort();
    functionontypechange();
  });
  

  window.displayVal2.onfocus = function()
  {
    window.displayVal2.type = "number";
    window.displayVal2.value = window.displayVal2.getAttribute("current-budget-input");
  }
  window.displayVal2.oninput = function()
  {
    window.displayVal2.value = window.displayVal2.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  }
  window.displayVal2.addEventListener("focusout", (event) =>
  {
    let DataToDisplay;
    
    if(window.displayVal2.value == "")
    {
      DataToDisplay = parseInt(window.displayVal2.getAttribute("current-budget-input"));
    }
    else if(window.displayVal2.value >= sliderMaxValue)
    {
      DataToDisplay = sliderMaxValue;
    }
    else if(window.displayVal2.value < sliderMinValue)
    {
      DataToDisplay = 0;
    }
    else
    {
      DataToDisplay = window.displayVal2.value;
    }

    if(DataToDisplay < parseInt(window. displayVal1.getAttribute("current-budget-input")))
    {
     window.displayVal1.setAttribute("current-budget-input", DataToDisplay);
      ConvertToIDR(window.displayVal1, DataToDisplay);
      window.SliderMin.value = DataToDisplay;
    }

    window.displayVal2.setAttribute("current-budget-input", window.displayVal2.value);
    ConvertToIDR(window.displayVal2, DataToDisplay);

    window.SliderMax.value = DataToDisplay;

    ChangeSwiperColorRange();
    // window.LoadAccommodationBasedOnSort();
    functionontypechange();
  });

  //-------------------------- SET MIN AND MAX SLIDER -----------------------------

  window.SliderMin.max = sliderMaxValue;
  window.SliderMin.value = sliderMinValue;

  window.SliderMax.max = sliderMaxValue;
  window.SliderMax.value = sliderMaxValue;

  //-------------------------- SET INPUT FIELD VALUE -----------------------------

  window.displayVal1.setAttribute("current-budget-input", sliderMinValue);
  ConvertToIDR(window.displayVal1, sliderMinValue)

  window.displayVal2.setAttribute("current-budget-input", sliderMaxValue);
  ConvertToIDR(window.displayVal2, sliderMaxValue)

  //------------------------------------------------------------------------------
  ChangeSwiperColorRange();
}


window.GetMaxSliderValue = function()
{
  let CurrentHighest = 0;
  for(let i = 0; i < window.SortedAccommodationData.length; i++)
  {
    if(CurrentHighest < window.SortedAccommodationData[i].min_price)
    {
      CurrentHighest = window.SortedAccommodationData[i].min_price;
    }
  }
  let HowManyToDivide = Math.pow(10, parseInt(CurrentHighest.toString().length)-1);
  let GetRoundedMaxValue =  (Math.ceil(CurrentHighest/HowManyToDivide)*HowManyToDivide);

  if(GetRoundedMaxValue < 1000000)
  {
    GetRoundedMaxValue = 1000000;
  }

  if(GetRoundedMaxValue == 0)
  {
    sliderMaxValue = 1000000;
  }
  else
  {
    sliderMaxValue = GetRoundedMaxValue;
  }

  //============================= SET MAXIMUM FOR BOOTH ======================

  window.SliderMin.max = sliderMaxValue;
  window.SliderMax.max = sliderMaxValue;

  //============================== MIN SLIDER ================================

  if(window.SliderMin.value > sliderMaxValue)
  {
    window.SliderMin.value = sliderMaxValue;
   window.displayVal1.setAttribute("current-budget-input", window.SliderMin.value);
    ConvertToIDR(window.displayVal1, window.SliderMin.value);
  }

  //============================== MAX SLIDER ================================

  if(window.SliderMax.value < sliderMaxValue)
  {
    window.SliderMax.value = sliderMaxValue;
    window.displayVal2.setAttribute("current-budget-input", window.SliderMax.value);
    ConvertToIDR(window.displayVal2, window.SliderMax.value);
  }

  ChangeSwiperColorRange();
}

window.OnChangePriceSlider = function(whichfirstsection, whichsecondsection, variabletodisplay)
{
  if(parseInt(window.SliderMax.value) - parseInt(window.SliderMin.value) <= minGap)
  {
    if(whichfirstsection == "SliderMax")
    {
      window[whichsecondsection].value = parseInt(window[whichfirstsection].value) - minGap;
    }
    else
    {
      window[whichsecondsection].value = parseInt(window[whichfirstsection].value) + minGap;
    }
  }

  window[whichsecondsection].value = (Math.round(window[whichsecondsection].value/100)) * 100;
  window[variabletodisplay].setAttribute("current-budget-input", window[whichsecondsection].value);
  ConvertToIDR(window[variabletodisplay], window[whichsecondsection].value);

  ChangeSwiperColorRange();
}

//======================================== VISUAL OUTPUT ============================================

function ConvertToIDR(whichinput, value)
{
  whichinput.type = "text";
  whichinput.value = "Rp " + parseInt(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function ChangeSwiperColorRange()
{
  let percent1 = (window.SliderMin.value / sliderMaxValue) * 100;
  let percent2 = (window.SliderMax.value / sliderMaxValue) * 100;
  window.sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #50A9E1 ${percent1}% , #50A9E1 ${percent2}%, #dadae5 ${percent2}%)`;
}
